import { t } from '../i18n';

// eslint-disable-next-line import/prefer-default-export
export const footer = {
    title: t('CONTACT_US'),
    email: 'info@szolidarisgazdasag.hu',
};
